import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, startWith, fromEvent, Subscription, merge } from 'rxjs';
import { SetVisoreHero1 } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-hero',
  templateUrl: './sample-hero.component.html',
  styleUrls: ['./sample-hero.component.scss']
})
export class SampleHeroComponent implements OnInit {

  @Input() block: SetVisoreHero1 = {} as SetVisoreHero1;
  public domainWebsite = environment.urlApi;
  public imgPath = "";
  public testoAlt = "";
  public isLinkEsternal: boolean = false;

  constructor(
    public helperService: HelpersService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.isLinkEsternal = this.block.link_cta ? this.helperService.verifyLinkExternal(this.block.link_cta.url) : false;
    this.imgPath = this.domainWebsite + this.helperService.retrieveImage(this.block.immagine, "src");
    this.testoAlt = this.helperService.retrieveImage(this.block.immagine, "alt");
  }

}
